import { type ReactElement } from 'react';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';
import PageShell, { PageSection } from '../components/PageShell';

export default function Kontakt(): ReactElement {
  return (
    <PageShell
      title="Kontakt"
      intro="Wir helfen gerne weiter – ob bei Fragen zur Software, zu Ihrem Konto oder zur Zusammenarbeit."
    >
      <PageSection title="So erreichen Sie uns">
        <ul className="space-y-4">
          <li className="flex items-start gap-3">
            <Mail className="w-5 h-5 text-primary-600 mt-0.5 shrink-0" />
            <span>
              E-Mail:{' '}
              <a href="mailto:info@saldify.de" className="text-primary-600 hover:underline">
                info@saldify.de
              </a>
            </span>
          </li>
          <li className="flex items-start gap-3">
            <Phone className="w-5 h-5 text-primary-600 mt-0.5 shrink-0" />
            <span>Telefon: (030) 89 39 91 47</span>
          </li>
          <li className="flex items-start gap-3">
            <MapPin className="w-5 h-5 text-primary-600 mt-0.5 shrink-0" />
            <span>CuiveMedia, Siriusstraße 2, 12524 Berlin</span>
          </li>
          <li className="flex items-start gap-3">
            <Clock className="w-5 h-5 text-primary-600 mt-0.5 shrink-0" />
            <span>Mo–Fr 9:00–18:00 Uhr, Sa nach Vereinbarung</span>
          </li>
        </ul>
      </PageSection>

      <PageSection title="Support">
        <p>
          Bei Fragen rund um die Nutzung von Saldify finden Sie viele Antworten in
          unserem{' '}
          <a href="/hilfe" className="text-primary-600 hover:underline">
            Hilfe-Center
          </a>
          . Kommen Sie dort nicht weiter, melden Sie sich einfach per E-Mail – wir
          antworten in der Regel innerhalb eines Werktags.
        </p>
      </PageSection>
    </PageShell>
  );
}
